<template>
    <Layout header-class="header-left-align" nav-alignment="left">
        <div class="rn-terms-area rn-section-gap" :class="{ 'text-white': !userLogin, 'text-black': userLogin }">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <SectionTitle text-align="center" :subtitle="$t('Legal.terms_condition')"
                            :title="$t('Legal.terms_condition')" data-aos="fade-up" />
                    </div>
                </div>
                <div class="row mt--40">
                    <div class="col-lg-10 offset-lg-1">
                        <div class="content LexenRegular" data-aos="fade-up" data-aos-delay="100">
                            <template v-if="$i18n.locale === 'en'">
                                <h4 :class="{ 'text-white': !userLogin }">1. Acceptance of Terms</h4>
                                <p>
                                    By using HubThings EV Roaming Hub, you agree to comply with and be bound by these
                                    Terms and Conditions. If you do not agree to these terms, please refrain from
                                    using our services.
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">2. Use of Services</h4>
                                <p>
                                    Our services are provided for personal and commercial use in accordance with your
                                    membership plan. You agree not to misuse our platform for any unlawful activities.
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">3. Membership and Billing</h4>
                                <p>
                                    Subscription plans are billed monthly. You can cancel your membership at any time.
                                    Refunds are subject to our refund policy.
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">4. Liability Limitation</h4>
                                <p>
                                    HubThings is not liable for any direct or indirect damages resulting from the use
                                    or inability to use our EV Roaming Hub services.
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">5. Changes to Terms</h4>
                                <p>
                                    We reserve the right to update these Terms and Conditions at any time. Changes
                                    will be effective immediately upon posting.
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">6. Governing Law</h4>
                                <p>
                                    These terms are governed by the laws of Thailand. Any disputes will be subject to
                                    the jurisdiction of the courts of Bangkok.
                                </p>
                            </template>
                            <template v-else>
                                <h4 :class="{ 'text-white': !userLogin }">1. การยอมรับข้อกำหนด</h4>
                                <p>
                                    โดยการใช้ HubThings EV Roaming Hub
                                    แสดงว่าคุณตกลงที่จะปฏิบัติตามและผูกพันตามข้อกำหนดและเงื่อนไขเหล่านี้
                                    หากคุณไม่ตกลงตามข้อกำหนดเหล่านี้ โปรดงดเว้นจากการใช้บริการของเรา
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">2. การใช้บริการ</h4>
                                <p>
                                    บริการของเราจัดทำขึ้นเพื่อการใช้งานส่วนบุคคลและเชิงพาณิชย์ตามแผนสมาชิกของคุณ
                                    คุณตกลงที่จะไม่ใช้แพลตฟอร์มของเราในทางที่ผิดสำหรับกิจกรรมที่ผิดกฎหมายใดๆ
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">3. การเป็นสมาชิกและการเรียกเก็บเงิน</h4>
                                <p>
                                    แผนการสมัครสมาชิกจะเรียกเก็บเงินรายเดือน คุณสามารถยกเลิกการเป็นสมาชิกได้ตลอดเวลา
                                    การคืนเงินจะเป็นไปตามนโยบายการคืนเงินของเรา
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">4. ข้อจำกัดความรับผิด</h4>
                                <p>
                                    HubThings
                                    ไม่รับผิดชอบต่อความเสียหายโดยตรงหรือโดยอ้อมที่เกิดจากการใช้งานหรือการไม่สามารถใช้บริการ
                                    EV Roaming Hub ของเราได้
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">5. การเปลี่ยนแปลงข้อกำหนด</h4>
                                <p>
                                    เราขอสงวนสิทธิ์ในการปรับปรุงข้อกำหนดและเงื่อนไขเหล่านี้ได้ตลอดเวลา
                                    การเปลี่ยนแปลงจะมีผลทันทีเมื่อมีการโพสต์
                                </p>

                                <h4 :class="{ 'text-white': !userLogin }">6. กฎหมายที่ใช้บังคับ</h4>
                                <p>
                                    ข้อกำหนดเหล่านี้อยู่ภายใต้กฎหมายของประเทศไทย ข้อพิพาทใดๆ
                                    จะขึ้นอยู่กับเขตอำนาจศาลของกรุงเทพมหานคร
                                </p>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Layout from '../components/common/Layout'
import SectionTitle from '../components/elements/sectionTitle/SectionTitle'
import i18n from '../../i18n/i18n'

export default {
    name: 'TermsAndCondition',
    i18n,
    components: {
        SectionTitle,
        Layout
    },
    computed: {
        userLogin() {
            return this.$store.state.userLogin
        }
    }
}
</script>

<style scoped>
.rn-terms-area {
    min-height: 600px;
}

.content h4 {
    margin-top: 30px;
    margin-bottom: 15px;
}

.content p {
    line-height: 1.8;
    margin-bottom: 20px;
}
</style>
